import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function TeleclipperPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-100 py-4">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-2 text-sm">
          <h5 className="font-semibold text-[#333333]">TELECLIPPER</h5>
          <h5 className="text-[#999999]">/</h5>
          <h5><Link to="/" className="text-[#14B8A6] hover:underline">Home</Link></h5>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Images and Video */}
          <div>
            <div className="mb-6">
              <img 
                              src="/images/664-ED02.jpg" 
                alt="Tree Clipper" 
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-6">
              <img 
                              src="/images/EDTC_02.jpg" 
                alt="Tree Puller" 
                className="w-full h-auto rounded-lg shadow-md"
              />
              <img 
                              src="/images/EDHC_v01.jpg" 
                alt="Tree Clipper" 
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
            
            
          </div>

          {/* Right Column - Product Info */}
          <div>
            
            
            <h1 className="text-4xl font-bold text-[#333333] mb-4">TELECLIPPER</h1>
            <h4 className="text-xl font-semibold text-[#666666] mb-2">Model: TC6451</h4>
            <h4 className="text-xl font-semibold text-[#666666] mb-6">Weight: 1038 lbs</h4>

            <div className="prose max-w-none mb-8">
              <h2 className="text-2xl font-bold text-[#333333] mb-4">Extreme Duty Tree Cutting Equipment With Industry Leading Reach!</h2>
              
              <p className="text-[#666666] mb-4">
                The Heavy Duty HyReach TeleClipper is our longest reach tree cutting tool ever! The boom extends the cutting surface up to 10' 3" and will retract to 7' 3". The 180⁰ rotation of the clipper head allows close cutting on both sides of the tree without repositioning equipment. The TC6451 TeleClipper features our strongest clipper head – Model 664000.
              </p>

              <p className="text-[#666666] mb-4">
                All of the cutting, rotating and telescoping is controlled from inside the cab with a wireless remote. Or if your skid steer has electrical outlets choose our 14 PIN or 8 PIN connectors for controlling the cutting, rotating, and telescoping. You will be able to choose which buttons on your control handle will control the rotation and telescoping features by choosing the pin locations on the connector.
              </p>

              <p className="text-[#666666] mb-4">
                Our customers have requested higher clearance along fence rows and right-of-ways and this piece of tree cutting equipment delivers. Scratches, broken glass, and mirrors on combines and other equipment can now be avoided. The longer reach is often required for clearing ditches and waterway beds.
              </p>

              <p className="text-[#666666] mb-6">
                The HyReach Teleclipper is built for the most demanding conditions, so trust Precision Manufacturing for your tree cutting and land clearing equipment!
              </p>

              

              <h2 className="text-2xl font-bold text-[#333333] mb-4">Frequently Asked Questions</h2>

              <p className="mb-3">
                <strong className="text-[#333333]">Q: What is the maximum reach of the HyReach TeleClipper?</strong><br />
                <strong className="text-[#333333]">A:</strong> The HyReach TeleClipper extends to a maximum reach of 10′ 3″ and can retract to 7′ 3″, providing exceptional versatility for tree-cutting and land-clearing tasks.
              </p>

              <p className="mb-3">
                <strong className="text-[#333333]">Q: How is the TeleClipper controlled?</strong><br />
                <strong className="text-[#333333]">A:</strong> The TeleClipper can be controlled from inside your cab using a wireless remote. Alternatively, if your skid steer has electrical outlets, you can use 14 PIN or 8 PIN connectors to control cutting, rotating, and telescoping functions.
              </p>

              <p className="mb-6">
                <strong className="text-[#333333]">Q: What applications is the HyReach TeleClipper best suited for?</strong><br />
                <strong className="text-[#333333]">A:</strong> The HyReach TeleClipper is ideal for fence row clearing, land clearing, maintaining ditches and waterways, and any tree-cutting tasks that require extended reach while protecting your equipment from damage.
              </p>
            </div>

            <hr className="border-gray-300 mb-6" />

            {/* Features Accordion */}
            <div className="mb-8">
              <details className="group">
                <summary className="flex items-center justify-between cursor-pointer list-none p-4 bg-[#f8f8f8] rounded-lg font-bold text-[#333333]">
                  <span>FEATURES</span>
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="p-4 bg-white">
                  <ul className="list-disc list-inside space-y-2 text-[#666666]">
                    <li>664000 Extreme Duty Clipper Head</li>
                    <li>Rectangular Boom for Maximum Strength</li>
                    <li>Wireless Remote to Control Cutting, Rotating and Telescoping</li>
                    <li>Limb Guard</li>
                    <li>Skid Steer Quick Attach Brackets</li>
                    <li>Flat Face Couplers</li>
                  </ul>
                </div>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-4 mb-8">
              <a 
                href="/contact" 
                className="bg-[#14B8A6] text-white text-center px-8 py-3 font-bold hover:bg-[#0f9b8e] transition-colors whitespace-nowrap"
              >
                Call Us Now
              </a>
              
              
            </div>
          </div>
        </div>
      </div>

    
      {/* Disclaimer */}
      <div className="bg-white py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold text-[#333333] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

     
    </div>
  );
}
